var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect11, _rect12, _path11, _rect13, _rect14, _path12, _rect15, _g, _rect16, _path13, _line, _path14, _path15, _line2, _path16, _path17, _path18, _path19, _path20, _rect17, _path21, _path22, _path23, _rect18, _rect19, _path24, _circle7, _path25, _path26, _path27, _path28, _path29, _path30, _rect20, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSellAnything(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 659,
    height: 721,
    viewBox: "0 0 659 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 472H179.571C183.122 472 186 474.878 186 478.429V720H9V472Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 464H171.571C175.122 464 178 466.878 178 470.429V720H1V464Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 505,
    width: 96,
    height: 8,
    rx: 4,
    fill: "#FFC900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 524,
    width: 112,
    height: 6,
    rx: 3,
    fill: "#D6D3D1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.8569,
    y: 675,
    width: 120.857,
    height: 5.78571,
    rx: 2.89286,
    fill: "#D6D3D1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2144,
    y: 565.071,
    width: 59.7857,
    height: 5.78571,
    rx: 2.89286,
    fill: "#D6D3D1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 582,
    width: 55,
    height: 6,
    rx: 3,
    fill: "#D6D3D1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2144,
    y: 599.786,
    width: 74.5714,
    height: 5.14286,
    rx: 2.57143,
    fill: "#D6D3D1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 617,
    width: 68,
    height: 5,
    rx: 2.5,
    fill: "#D6D3D1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.2144,
    y: 633.857,
    width: 86.1429,
    height: 5.78571,
    rx: 2.89286,
    fill: "#D6D3D1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 651,
    width: 75,
    height: 6,
    rx: 3,
    fill: "#D6D3D1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 538.286,
    width: 97.7143,
    height: 5.78571,
    rx: 2.89286,
    fill: "#D6D3D1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6426,
    cy: 567.643,
    r: 5.78571,
    fill: "#23A094"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6426,
    cy: 585,
    r: 5.78571,
    fill: "#23A094"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6426,
    cy: 602.357,
    r: 5.78571,
    fill: "#23A094"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6426,
    cy: 619.714,
    r: 5.78571,
    fill: "#23A094"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6426,
    cy: 637.071,
    r: 5.78571,
    fill: "#23A094"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6426,
    cy: 653.786,
    r: 5.78571,
    fill: "#23A094"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 568.299L28.5307 569.571L31.5713 566.357",
    stroke: "white",
    strokeWidth: 0.366541
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 585.402L28.5307 586.929L31.5713 583.071",
    stroke: "white",
    strokeWidth: 0.366541
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 602.759L28.5307 604.286L31.5713 600.429",
    stroke: "white",
    strokeWidth: 0.366541
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 620.116L28.5307 621.643L31.5713 617.786",
    stroke: "white",
    strokeWidth: 0.366541
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 637.085L28.5307 638.357L31.5713 635.143",
    stroke: "white",
    strokeWidth: 0.366541
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0713 654.442L28.5307 655.714L31.5713 652.5",
    stroke: "white",
    strokeWidth: 0.366541
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0L320 0V244.571C320 248.122 317.122 251 313.571 251H1.5V0Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H312V236.571C312 240.122 309.122 243 305.571 243H2V0Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 344.143,
    width: 378.659,
    height: 233.021,
    rx: 6.42857,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 336.143,
    width: 378.659,
    height: 233.021,
    rx: 6.42857,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273.846 549.262V537.82C273.846 536.197 275.534 535.125 277.003 535.816L288.445 541.201C290.096 541.978 290.151 544.307 288.538 545.161L277.096 551.219C275.621 552 273.846 550.93 273.846 549.262Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 301.974,
    y: 540.035,
    width: 298.558,
    height: 7.2819,
    rx: 3.64095,
    fill: "#F4F4F0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 301.974,
    y: 540.035,
    width: 145.638,
    height: 7.2819,
    rx: 3.64095,
    fill: "#FFC900"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M622.857 336H257.714C254.164 336 251.286 338.878 251.286 342.429V523H629.286V342.429C629.286 338.878 626.408 336 622.857 336Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_970_15880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 327,
    y: 347,
    width: 152,
    height: 176
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 327.286,
    y: 347,
    width: 151,
    height: 176,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_970_15880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.242 383.383V402.006C463.242 406.882 461.306 411.558 457.858 415.005C454.411 418.452 449.735 420.389 444.86 420.389H429.13C427.203 420.389 425.295 420.769 423.515 421.506C421.735 422.244 420.118 423.325 418.756 424.687C417.394 426.05 416.313 427.667 415.576 429.448C414.839 431.228 414.46 433.136 414.461 435.063V465.482H361.286V383.383C361.286 378.507 363.222 373.832 366.67 370.384C370.117 366.937 374.793 365 379.668 365H444.86C449.735 365 454.411 366.937 457.858 370.384C461.306 373.832 463.242 378.507 463.242 383.383V383.383Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.496 465.5V481.416H437.675V469H458.286V487.966C458.286 489.529 457.976 491.076 457.376 492.52C456.775 493.964 455.895 495.275 454.785 496.38C453.675 497.485 452.357 498.362 450.906 498.96C449.456 499.558 447.902 499.866 446.332 499.866H415.85V534H361.286V496.497C361.284 494.287 361.721 492.098 362.571 490.056C363.42 488.014 364.666 486.159 366.237 484.597C367.808 483.035 369.672 481.797 371.725 480.954C373.777 480.11 375.976 479.678 378.196 479.681H388.334V465.5H406.496Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.425 468.981C458.425 456.675 462.612 436.101 458.425 434.169C454.237 432.236 444.932 431.6 441.713 432.241C438.493 432.882 444.909 445.745 442.225 446.901C439.54 448.056 439.028 435.587 434.553 438.946C430.077 442.306 438.898 453.863 438.898 453.863L437.502 469L458.425 468.981Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.285 397.629C449.728 397.629 451.708 395.649 451.708 393.206C451.708 390.763 449.728 388.782 447.285 388.782C444.842 388.782 442.861 390.763 442.861 393.206C442.861 395.649 444.842 397.629 447.285 397.629Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.066 397.629C379.509 397.629 381.49 395.649 381.49 393.206C381.49 390.763 379.509 388.782 377.066 388.782C374.623 388.782 372.643 390.763 372.643 393.206C372.643 395.649 374.623 397.629 377.066 397.629Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 507.714,
    y: 397.291,
    width: 24.4286,
    height: 51.4286,
    rx: 12.2143,
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M538.571 435.862C538.571 446.158 530.225 454.505 519.929 454.505C509.632 454.505 501.286 446.158 501.286 435.862",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 520.286,
    y1: 454.505,
    x2: 520.286,
    y2: 522.648,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M507.714 420H532.464",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M507.714 426.862H532.464",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 251.286,
    y1: 523,
    x2: 629.286,
    y2: 523,
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.643 45.0207L202.058 75.2828C202.986 75.8187 203.558 76.809 203.558 77.8808V138.405C203.558 139.477 202.986 140.467 202.058 141.003L149.643 171.265C148.715 171.801 147.571 171.801 146.643 171.265L94.2275 141.003C93.2993 140.467 92.7275 139.477 92.7275 138.405V77.8808C92.7275 76.809 93.2993 75.8187 94.2275 75.2828L146.643 45.0207C147.571 44.4848 148.715 44.4848 149.643 45.0207Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M203.794 76.1143L150.084 107.124C148.847 107.838 147.322 107.838 146.084 107.124L92.374 76.1143",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M148.143 172.743V108.143",
    stroke: "black",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M322.429 642.643H558.571C561.767 642.643 564.357 645.233 564.357 648.429V720.357H316.643V648.429C316.643 645.233 319.233 642.643 322.429 642.643Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.28571
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M314.429 635.643H550.571C553.767 635.643 556.357 638.233 556.357 641.429V720.357H308.643V641.429C308.643 638.233 311.233 635.643 314.429 635.643Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.28571
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 344.949,
    y: 703,
    width: 50.6032,
    height: 4.5,
    rx: 2.25,
    fill: "#D6D3D1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M502.827 702.621V707.808C502.827 708.251 502.389 708.561 501.971 708.415L494.564 705.821C493.99 705.62 493.99 704.809 494.564 704.608L501.971 702.014C502.389 701.867 502.827 702.178 502.827 702.621Z",
    fill: "#D6D3D1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M511.573 702.664V707.765C511.573 708.22 512.033 708.531 512.455 708.362L518.828 705.811C519.367 705.596 519.367 704.833 518.828 704.618L512.455 702.067C512.033 701.898 511.573 702.209 511.573 702.664Z",
    fill: "#23A094"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M348.032 675.802H353.24C356.624 675.802 358.688 673.522 358.688 670.858C358.688 668.122 356.72 665.914 353.24 665.914H345.824V682.714H348.032V675.802ZM348.032 673.714V668.002H353.048C355.04 668.002 356.36 669.034 356.36 670.858C356.36 672.682 355.04 673.714 353.048 673.714H348.032ZM360.314 679.474C360.314 680.53 360.674 681.37 361.394 682.018C362.138 682.642 363.026 682.954 364.082 682.954C365.906 682.954 367.418 682.138 367.994 680.914V682.714H369.986V675.586C369.986 672.778 368.234 671.098 365.138 671.098C362.474 671.098 360.698 672.49 360.242 674.674L362.114 675.202C362.402 673.738 363.506 672.85 365.138 672.85C366.842 672.85 367.994 673.762 367.994 675.418V676.594L366.962 676.306C366.194 676.066 365.378 675.946 364.538 675.946C362.066 675.946 360.314 677.146 360.314 679.474ZM367.994 678.466C367.994 680.122 366.674 681.13 364.778 681.13C363.266 681.13 362.45 680.41 362.45 679.354C362.45 678.178 363.362 677.554 364.826 677.554C365.426 677.554 366.146 677.674 366.938 677.914L367.994 678.226V678.466ZM380.141 671.338L376.757 678.826L373.565 671.338H371.309L375.653 681.25L372.845 687.466H375.053L382.349 671.338H380.141ZM409.363 682.714V665.914H405.259L399.859 681.058L394.459 665.914H390.379V682.714H392.587V667.09L398.179 682.714H401.539L407.155 667.09V682.714H409.363ZM412.084 677.026C412.084 680.386 414.412 682.954 417.844 682.954C421.252 682.954 423.628 680.386 423.628 677.026C423.628 673.666 421.3 671.098 417.844 671.098C414.412 671.098 412.084 673.666 412.084 677.026ZM421.492 677.026C421.492 679.426 419.98 681.082 417.844 681.082C415.732 681.082 414.196 679.402 414.196 677.026C414.196 674.65 415.732 672.97 417.844 672.97C418.924 672.97 419.788 673.354 420.46 674.122C421.156 674.866 421.492 675.85 421.492 677.026ZM428.18 682.714V676.474C428.18 674.29 429.524 672.922 431.252 672.922C432.884 672.922 433.844 673.954 433.844 675.946V682.714H435.932V675.322C435.932 672.658 434.348 671.098 431.924 671.098C430.316 671.098 428.972 671.866 428.18 673.186V671.338H426.116V682.714H428.18ZM440.042 679.33C440.042 681.61 441.362 682.954 443.762 682.954C445.706 682.954 447.002 681.826 447.314 679.786L445.394 679.354C445.202 680.602 444.65 681.13 443.69 681.13C442.802 681.13 442.13 680.506 442.13 679.426V673.09H446.21V671.338H442.13V667.81H440.042V671.338H437.786V673.09H440.042V679.33ZM451.5 682.714V676.834C451.5 674.482 452.94 672.874 454.764 672.874C456.492 672.874 457.476 673.882 457.476 675.826V682.714H459.564V675.346C459.564 672.754 458.004 671.098 455.508 671.098C453.66 671.098 452.148 672.106 451.5 673.738V665.914H449.436V682.714H451.5ZM462.749 682.714H464.813V665.914H462.749V682.714ZM475.438 671.338L472.054 678.826L468.862 671.338H466.606L470.95 681.25L468.142 687.466H470.35L477.646 671.338H475.438Z",
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 409,
    y: 57.2143,
    width: 248.143,
    height: 223.071,
    rx: 6.42857,
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 48.2143,
    width: 248.143,
    height: 223.071,
    rx: 6.42857,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M401 54.4286C401 50.8782 403.878 48 407.429 48H642.571C646.122 48 649 50.8782 649 54.4286V73H401V54.4286Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.321429
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 629.673,
    cy: 60.9025,
    r: 5.5,
    fill: "#FFC900"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.012 67.094C533.207 66.8143 534.097 65.7418 534.097 64.4614C534.097 62.9683 532.887 61.7579 531.394 61.7579C530.618 61.7579 529.919 62.0842 529.426 62.607L529.424 62.6031C528.821 63.2929 527.216 64.6105 525.184 64.7232C525.051 64.7306 524.96 64.8662 525.017 64.9865C526.378 67.8461 530.169 67.5874 532.012 67.094Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M539.19 55.4689L533.46 60.053C533.321 60.1637 533.407 60.4229 533.581 60.4561C533.903 60.5176 534.307 60.6528 534.639 60.9478C535.064 61.3253 535.283 61.9197 535.381 62.2745C535.414 62.3912 535.571 62.4325 535.65 62.3413L540.482 56.8194C540.834 56.4172 540.779 55.8027 540.362 55.4689C540.019 55.1948 539.533 55.1948 539.19 55.4689Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M557.714 56.2114C557.354 56.1301 556.977 56.2361 556.716 56.4918L554.486 58.677C554.068 59.0867 554.068 59.751 554.486 60.1607L556 61.6443C556.418 62.054 556.418 62.7182 556 63.1279L554.486 64.6116C554.068 65.0213 554.068 65.6855 554.486 66.0952C554.904 66.5049 555.582 66.5049 556 66.0952L560.921 61.2734C561.13 61.0685 561.469 61.0685 561.678 61.2734C561.887 61.4782 562.226 61.4782 562.435 61.2734L563.391 60.3358C563.509 60.2206 563.597 60.0802 563.65 59.9257L564.118 58.5503C564.246 58.1733 564.146 57.7577 563.859 57.4767L562.056 55.7097C561.638 55.3 560.96 55.3 560.542 55.7097L560.016 56.2259C559.755 56.4816 559.377 56.5876 559.018 56.5063L557.714 56.2114Z",
    fill: "#D6D3D1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M558.65 65.7243C558.441 65.5195 558.441 65.1873 558.65 64.9825L562.656 61.0561C562.994 60.7257 563.57 60.9597 563.57 61.427C563.57 61.5662 563.514 61.6996 563.413 61.798L559.407 65.7243C559.198 65.9292 558.859 65.9292 558.65 65.7243Z",
    fill: "#D6D3D1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M581.048 65.7807L581.158 65.6708C581.511 65.317 581.511 64.7434 581.158 64.3896L578.688 61.9183C578.334 61.5645 577.761 61.5645 577.408 61.9183L576.438 62.8886C576.084 63.2424 576.084 63.816 576.438 64.1698L578.048 65.7807C578.876 66.6097 580.219 66.6097 581.048 65.7807Z",
    fill: "#D6D3D1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M583.298 56.0242L579.438 59.8866C579.084 60.2404 579.084 60.814 579.438 61.1678L581.908 63.6392C582.261 63.9929 582.834 63.9929 583.188 63.6392L587.908 58.9163C588.261 58.5625 588.261 57.9889 587.908 57.6351L586.298 56.0242C585.469 55.1952 584.126 55.1952 583.298 56.0242Z",
    fill: "#D6D3D1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 601.901,
    y: 57.1307,
    width: 8.52088,
    height: 8.52088,
    rx: 0.160714,
    fill: "#D6D3D1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M612.553 55.1607C612.553 55.072 612.481 55 612.392 55H604.192C604.104 55 604.032 55.072 604.032 55.1607V55.9044C604.032 55.9931 604.104 56.0651 604.192 56.0651H611.326C611.415 56.0651 611.487 56.1371 611.487 56.2258V63.3602C611.487 63.4489 611.558 63.5209 611.647 63.5209H612.392C612.481 63.5209 612.553 63.4489 612.553 63.3602V55.1607Z",
    fill: "#D6D3D1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M453.097 178.125C452.548 179.813 453.472 181.626 455.16 182.175C456.848 182.724 458.661 181.8 459.21 180.112L453.097 178.125ZM533.48 165.9L535.308 163.256L533.48 165.9ZM609.997 154.846L611.362 151.936L605.542 149.206L604.177 152.116L609.997 154.846ZM459.21 180.112C461.848 171.997 471.27 163.16 484.689 159.345C497.906 155.587 514.714 156.83 531.651 168.544L535.308 163.256C516.777 150.44 497.98 148.882 482.931 153.161C468.083 157.383 456.576 167.419 453.097 178.125L459.21 180.112ZM531.651 168.544C549.661 180.999 567.188 182.097 581.279 177.753C595.187 173.467 605.768 163.861 609.997 154.846L604.177 152.116C600.811 159.291 591.785 167.788 579.386 171.61C567.171 175.375 551.691 174.587 535.308 163.256L531.651 168.544Z",
    fill: "#23A094"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellAnything);
export default __webpack_public_path__ + "static/media/SellAnything.f41792229ebb8551b6b36b9197b47151.svg";
export { ForwardRef as ReactComponent };